import { useEffect, useState } from 'react';
import { api } from '../api';

const MODULE_CN: any = {
  system: '系统设置', finance: '财务', products: '产品', sales: '销售报货',
  inventory: '库存', production: '生产', customer: '客户报货', attendance: '考勤',
};
const ACTION_CN: any = { view: '查看', create: '新增', edit: '编辑', delete: '删除', export: '导出', approve: '审批' };
const SCOPE_CN: any = { all: '全部数据', dept: '本部门', self: '仅本人' };
const ACTIONS = ['view', 'create', 'edit', 'delete', 'export', 'approve'];

export default function Roles() {
  const [roles, setRoles] = useState<any[]>([]);
  const [perms, setPerms] = useState<any[]>([]);
  const [form, setForm] = useState<any>({ id: null, name: '', code: '', description: '', data_scope: 'all', permission_ids: [] });

  const load = () => {
    api('/roles').then(setRoles).catch(() => {});
    api('/permissions').then(setPerms).catch(() => {});
  };
  useEffect(load, []);

  const submit = async () => {
    if (!form.name || !form.code) return alert('名称和编码必填');
    if (form.id) await api('/roles/' + form.id, { method: 'PUT', body: JSON.stringify(form) }).catch(() => {});
    else await api('/roles', { method: 'POST', body: JSON.stringify(form) }).catch(() => {});
    setForm({ id: null, name: '', code: '', description: '', data_scope: 'all', permission_ids: [] });
    load();
  };

  const edit = (r: any) =>
    setForm({
      id: r.id, name: r.name, code: r.code, description: r.description,
      data_scope: r.data_scope || 'all', permission_ids: r.permissions.map((p: any) => p.id),
    });

  const del = async (id: number) => {
    if (!confirm('确认删除该角色？')) return;
    await api('/roles/' + id, { method: 'DELETE' }).catch(() => {});
    load();
  };

  // 权限矩阵：module -> action -> permission
  const permMap: any = {};
  perms.forEach((p) => {
    permMap[p.module] = permMap[p.module] || {};
    permMap[p.module][p.action] = p;
  });
  const modules = Object.keys(MODULE_CN).filter((m) => permMap[m]);

  const toggle = (pid: number) => {
    const v = [...form.permission_ids];
    const i = v.indexOf(pid);
    if (i >= 0) v.splice(i, 1); else v.push(pid);
    setForm({ ...form, permission_ids: v });
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">角色与权限</h2>

      {/* 编辑/新建表单 */}
      <div className="bg-white rounded-xl shadow p-4 space-y-3">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          <input className="border rounded px-2 py-1.5" placeholder="角色名称" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input className="border rounded px-2 py-1.5" placeholder="角色编码" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
          <input className="border rounded px-2 py-1.5" placeholder="描述" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <label className="text-sm flex flex-col">
            <span className="text-xs text-slate-500 mb-1">数据范围</span>
            <select className="border rounded px-2 py-1.5" value={form.data_scope} onChange={(e) => setForm({ ...form, data_scope: e.target.value })}>
              {Object.entries(SCOPE_CN).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
        </div>

        {/* 权限矩阵 */}
        <div className="overflow-x-auto">
          <table className="w-full text-sm border">
            <thead>
              <tr className="bg-slate-50 text-slate-500">
                <th className="p-2 text-left">模块</th>
                {ACTIONS.map((a) => <th key={a} className="p-2 text-center">{ACTION_CN[a]}</th>)}
              </tr>
            </thead>
            <tbody>
              {modules.map((m) => (
                <tr key={m} className="border-t">
                  <td className="p-2 font-medium">{MODULE_CN[m]}</td>
                  {ACTIONS.map((a) => {
                    const p = permMap[m][a];
                    return (
                      <td key={a} className="p-2 text-center">
                        {p ? (
                          <input
                            type="checkbox"
                            checked={form.permission_ids.includes(p.id)}
                            onChange={() => toggle(p.id)}
                            title={`${MODULE_CN[m]} ${ACTION_CN[a]}`}
                          />
                        ) : <span className="text-slate-300">—</span>}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-slate-400">勾选即授予该模块对应操作的权限；数据范围控制可见数据（全部 / 仅本部门 / 仅本人创建）。</p>

        <div className="flex gap-2">
          <button onClick={submit} className="bg-brand-600 text-white rounded px-3 py-1.5 hover:bg-brand-700">{form.id ? '保存修改' : '新建角色'}</button>
          {form.id && (
            <button onClick={() => setForm({ id: null, name: '', code: '', description: '', data_scope: 'all', permission_ids: [] })} className="border rounded px-3 py-1.5">
              取消
            </button>
          )}
        </div>
      </div>

      {/* 角色列表 */}
      <table className="w-full bg-white rounded-xl shadow text-sm">
        <thead>
          <tr className="text-slate-500 text-left">
            <th className="p-3">名称</th><th>编码</th><th>数据范围</th><th>权限数</th><th>描述</th><th></th>
          </tr>
        </thead>
        <tbody>
          {roles.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="p-3">{r.name}</td>
              <td>{r.code}</td>
              <td><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">{SCOPE_CN[r.data_scope] || r.data_scope}</span></td>
              <td>{r.permissions.length}</td>
              <td>{r.description}</td>
              <td className="space-x-2 whitespace-nowrap">
                <button className="text-brand-600" onClick={() => edit(r)}>编辑</button>
                <button className="text-red-500" onClick={() => del(r.id)}>删除</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
